<template>
    <ui-modal :title="'Delivery data for RFM item'" :large="true"
              :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="h-6 w-6 mt-2 ml-2 text-blue-500 far fa-truck"></i>
            </div>
        </template>
        <div class="mt-6">
            Delivery dates and quantities for <span class="font-bold"
                                                    v-text="rfmItem.material+' ('+rfmItem.quantity+')'"></span>
        </div>
        <!-- Headers -->
        <div class="mt-6">
            <div
                class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                <div class="border-l border-gray-200 px-2 py-1 -mx-px w-28 ">Date</div>
                <div class="border-l border-gray-200 px-2 py-1 -ml-px w-20">Qty</div>
                <div class="border-l border-gray-200 px-2 py-1 -ml-px flex-grow">Notes</div>
                <div class="border-l w-6"></div>
            </div>
        </div>
        <!-- Items -->
        <procurement-r-f-m-item-delivery-data-line v-for="(line, key) in lines"
                                                   :key="key"
                                                   ref="lines"
                                                   :line="line"
                                                   :rfmItem="rfmItem"
                                                   @removeItem="lines.splice(key,1)"
        ></procurement-r-f-m-item-delivery-data-line>
        <!-- NEW Delivery date Item-->
        <div class="flex border-t -mt-px border-gray-200 bg-white" v-if="loaded">
            <div class="flex flex-grow -ml-px bg-white mt-4">
                <ui-button-new small icon="fa fa-plus" @click="addLine">Add new delivery date</ui-button-new>
            </div>
        </div>
        <div class="text-red-600 mt-1 font-semibold" v-if="error" v-text="error"></div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" @click="update" :disabled="busy"
                               v-text="'Update'"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>

import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiModal from "../../ui/UiModal.vue";
import PageCell from "../../ui/PageCell.vue";
import * as math from "mathjs";
import ProcurementRFMItemDeliveryDataLine from "./ProcurementRFMItemDeliveryDataLine.vue";
import {cloneDeep} from "lodash";

export default {
    components: {
        ProcurementRFMItemDeliveryDataLine,
        PageCell,
        UiModal,
        UiButtonNew
    },
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        rfm: Object,
        rfmItem: Object,
    },
    data() {
        return {
            search: '',
            busy: false,
            purchaseOrders: [],
            loaded: false,
            math,
            lines: this.rfmItem.deliveryDates ? this.rfmItem.deliveryDates : [],
            error: false,
        }
    },
    methods: {
        addLine() {
            this.lines.push({
                date: '',
                quantity: '',
                notes: ''
            })
        },
        async update() {
            let original = cloneDeep(this.rfm.deliveryDates)
            this.rfmItem.deliveryDates = this.lines;
            this.error = false;
            try {
                await this.rfm.updateDeliveryDates();
                this.handle(this)
            } catch (e) {
                this.rfmItem.deliveryDates = original;
                this.error = 'Update failed! - Are all Dates in the correct format (YYYY-MM-DD)?'
            }
        }
    },
    async mounted() {
        console.log(this.rfmItem)
        this.loaded = true;
    }
}
</script>
